import React from "react";
import { Button, Tree, Upload } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useTechnicianModel } from "../technicianModel";
import { useNavModel } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { importPropsConfig } from "@/utils/importFile";
import { DetailType } from "../../../../types/ScmEnums"
import { AuthButton } from "@/components/auth/AuthButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
export const DataBox = () => {
    const { selectedRowKeys,
        detailDrawer: visible,
        updateEditFormVal,
        loadData,
        setDetailDrawer,
        setDetailType,
    } = useTechnicianModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const addDrawer = () => {
        setDetailDrawer(!visible)
        setDetailType(DetailType.add)
    }
    const onEdit1 = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            return;
        }
        setDetailDrawer(!visible)
        setDetailType(DetailType.edit)
    }
    const action = <>
        <AuthButton
            // resCode="TechnicianManagementAdd"
            resCode={ResourcesAuthBtn[mianCode]["TechnicianManagementAdd"]}
            
            onClick={addDrawer}
            // name="新增"
            name={Locale["Add"]}
        />
        <AuthButton
            // resCode="TechnicianManagementEdit"
            resCode={ResourcesAuthBtn[mianCode]["TechnicianManagementEdit"]}
            onClick={onEdit1}
             // name="编辑"
             name={Locale["Edit"]}
        />

        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={addDrawer}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onEdit1}
        >编辑</Button> */}
    </>

    return (
        <YhBox  title={action}>
            <DataTable />
        </YhBox>
    )
}
